"use client";

import { cobrandAuthClient } from "../auth/cobrandAuthClient";

/**
 * Cobrand auth state, backed by the better-auth session. The session identity is the
 * verified email only — it carries NO cbID (which co-brand the user is acting on is a
 * client-side selection; see CobrandContext).
 */
export function useCobrandAuth() {
    const { data, isPending, refetch } = cobrandAuthClient.useSession();
    const email = data?.user?.email ?? null;

    return {
        email,
        isAuthenticated: !!email,
        isLoading: isPending,
        // Forces a fresh /get-session read. Needed right after sign-in, because better-auth's
        // session store is a module-level cache that survives route changes (see LoginPage).
        refetch,
        signOut: () => cobrandAuthClient.signOut(),
    };
}
